import { Route, Routes } from "react-router-dom";
import TemplatesPage from "../../app/templates";
import TemplatesIDPage from "../../app/templates/id";

export default function TemplatesRoutes() {
  return (
    <Routes>
      <Route path="/" element={<TemplatesPage />} />
      <Route path="/:id" element={<TemplatesIDPage />} />
    </Routes>
  );
}
